import React from 'react';
import { SVG } from 'web-common/src/shared/design-system/Utilities';

export const StarV2: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <SVG width='12' height='12' viewBox='0 0 12 12' fill='none' {...props}>
    <path
      d='M8.12308 3.53602L11.3702 4.02778C11.6426 4.07462 11.8697 4.26196 11.9605 4.54297C12.0514 4.80056 11.9832 5.10498 11.7789 5.29232L9.41737 7.70431L9.98504 11.1232C10.0305 11.4043 9.91692 11.6853 9.68985 11.8492C9.46278 12.0365 9.16759 12.0365 8.91782 11.9194L6.01135 10.3036L3.08218 11.9194C2.85511 12.0365 2.53722 12.0365 2.33286 11.8492C2.10579 11.6853 1.99225 11.4043 2.03767 11.1232L2.58263 7.70431L0.221127 5.29232C0.0167656 5.10498 -0.0513547 4.80056 0.0394724 4.54297C0.1303 4.26196 0.357367 4.07462 0.629848 4.02778L3.89962 3.53602L5.35286 0.421512C5.46639 0.163921 5.71617 0 6.01135 0C6.28383 0 6.53361 0.163921 6.64714 0.421512L8.12308 3.53602Z'
      fill='currentColor'
    />
  </SVG>
);
